import React from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import {
  LinkedIn,
  Twitter,
  GitHub,
  Instagram,
  Facebook
} from '@mui/icons-material';

const SocialMediaMenu: React.FC = () => {
  const socialLinks = [
    { icon: <LinkedIn />, label: 'LinkedIn', url: 'https://www.linkedin.com/company/preciora' },
    // { icon: <Twitter />, label: 'Twitter', url: 'https://x.com/' },
    // { icon: <GitHub />, label: 'GitHub', url: '#' },
    { icon: <Instagram />, label: 'Instagram', url: 'https://www.instagram.com/preciorallc/' },
    { icon: <Facebook />, label: 'Facebook', url: 'https://www.facebook.com/preciorallc' }
  ];

  return (
    <Box
      sx={{
        position: 'fixed',
        right: 0,
        top: '50%',
        transform: 'translateY(-50%)',
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        padding: 1,
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        backdropFilter: 'blur(8px)',
        borderTopLeftRadius: '8px',
        borderBottomLeftRadius: '8px',
        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
        zIndex: 1000,
        transition: 'transform 0.3s ease',
        '&:hover': {
          transform: 'translateX(0) translateY(-50%)',
        },
        '&:not(:hover)': {
          transform: 'translateX(calc(100% - 40px)) translateY(-50%)',
        }
      }}
    >
      {socialLinks.map((social, index) => (
        <Tooltip key={index} title={social.label} placement="left">
          <IconButton
            href={social.url}
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              color: 'primary.main',
              '&:hover': {
                backgroundColor: 'primary.light',
                color: 'primary.dark',
                transform: 'scale(1.1)',
              },
              transition: 'all 0.2s ease',
            }}
          >
            {social.icon}
          </IconButton>
        </Tooltip>
      ))}
    </Box>
  );
};

export default SocialMediaMenu; 